import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

const Label = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

const LabelLine = styled.div`
  width: 4px;
  height: 20px;
  border-radius: 99px;
  background: #2f3c5e;
`

const LabelName = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`

const AddPatternLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  color: #2f3c5e;
  font-family: SUIT;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #57c9a7;
  }
`

interface Props {
  label: string
  to: string
}

const PatternLabelHeader = ({ label, to }: Props) => {
  return (
    <Wrapper>
      <Label>
        <LabelLine />
        <LabelName>{label}</LabelName>
      </Label>
      <AddPatternLink to={to}>+ 패턴 추가</AddPatternLink>
    </Wrapper>
  )
}

export default PatternLabelHeader
